<template>
  <div id="container">
    <van-form @submit="submit">
      <van-field
        v-model="cusUser.name"
        label="姓名"
        placeholder="请输入"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="cusUser.position"
        label="职务"
        placeholder="请输入"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="cusUser.invoice_title"
        label="开票抬头"
        placeholder="请输入"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="cusUser.birthday"
        is-link
        readonly
        name="datetimePicker"
        label="生日"
        placeholder="点击选择"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
          type="date"
          :min-date="new Date(1940, 0, 1)"
          @confirm="(value) => {
            cusUser.birthday = value.getFullYear() + '-' + (value.getMonth() + 1) + '-' + value.getDate()
            showPicker = false
          }"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        label="性别"
        disabled
      />
      <van-radio-group v-model="cusUser.gender">
        <van-cell-group inset>
          <van-cell title="男" clickable @click="cusUser.gender=1">
            <template #right-icon>
              <van-radio :name="1" />
            </template>
          </van-cell>
          <van-cell title="女" clickable @click="cusUser.gender=2">
            <template #right-icon>
              <van-radio :name="2" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-field
        v-model="cusUser.mobile"
        label="电话"
        placeholder="请输入"
        :rules="[{ required: true }]"
        disabled
      >
        <template #button>
          <van-button size="small" type="primary" native-type="button" @click="() => {$router.push({path: '/wei/user/mobile'})}">修改手机</van-button>
        </template>
      </van-field>
      <div v-if="cusCompany!==undefined">
        <van-field
          v-if="cusCompany.id!==undefined"
          v-model="cusCompany.name"
          label="公司"
          placeholder="请输入"
          :rules="[{ required: true }]"
          disabled
        >
          <template #button>
            <van-button size="small" type="primary" native-type="button" @click="() => {$router.push({path: '/bind'})}">重新认证</van-button>
          </template>
        </van-field>
        <van-field
          v-if="cusCompany.id!==undefined"
          :value="cusCompany.cus_industry_ids.join(',')"
          label="行业"
          placeholder="请输入"
          disabled
        />
      </div>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Api from '@/utils/api'
export default {
  created () {
    Api.post('wei.user/model', null, res => {
      if (res.data.headimgurl === '') res.data.headimgurl = require('@/assets/avatar.png')
      this.weiUser = res.data
      this.cusUser = res.data.cusUser
      this.cusCompany = res.data.cusCompany
    })
  },
  data () {
    return {
      cusUser: {},
      weiUser: {},
      cusCompany: {},
      showPicker: false
    }
  },
  methods: {
    submit () {
      this.$dialog.confirm({title: '提示', message: '确认修改吗？'})
        .then(() => {
          let params = {
            id: this.cusUser.id,
            name: this.cusUser.name,
            position: this.cusUser.position,
            gender: this.cusUser.gender,
            birthday: this.cusUser.birthday,
            invoice_title: this.cusUser.invoice_title
          }
          Api.post('cus.user/modify', params, res => {
            this.$router.push({path: '/home'})
          })
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/wei/user/Modify.vue